import { useState, useEffect } from 'react';
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../../lib/AuthContext';
import { LayoutDashboard, FileText, Settings, LogOut, BarChart3, PenTool } from 'lucide-react';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { to: '/admin/leads', label: 'Demandes démo', icon: FileText },
  { to: '/admin/blog', label: 'Blog', icon: PenTool },
  { to: '/admin/analytics', label: 'Analytics', icon: BarChart3 },
  { to: '/admin/settings', label: 'Paramètres', icon: Settings },
];

const AdminLayout = () => {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) return <div className="min-h-screen bg-[#09090b] flex items-center justify-center"><p className="text-[#71717a]">Chargement...</p></div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.to;
    return location.pathname.startsWith(item.to);
  };

  return (
    <div className="min-h-screen bg-[#09090b] flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-60 bg-[#0f0f17] border-r border-white/5 flex flex-col" data-testid="admin-sidebar">
        <div className="p-5 border-b border-white/5">
          <Link to="/" className="text-[#f5f5f5] font-bold text-lg">Cloneia</Link>
          <p className="text-[#71717a] text-xs mt-0.5">Back-office</p>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive(item)
                  ? 'bg-[#3b82f6]/10 text-[#3b82f6]'
                  : 'text-[#71717a] hover:text-[#a1a1aa] hover:bg-[#1a1a2e]/50'
              }`}
              data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
            >
              <item.icon className="w-4 h-4" />
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="p-3 border-t border-white/5">
          <button
            onClick={logout}
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-[#71717a] hover:text-red-400 hover:bg-red-400/5 transition-colors w-full"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" />
            Déconnexion
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
